module.exports = __webpack_public_path__ + "assets/c1f6c840c84f650955095e0e3dedf508.mp4";